import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import { task } from "ember-concurrency";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class PrivateNetworkSegmentModel extends Model {
  @attr name;
  @attr platform;
  @attr ipv4subnet;
  @attr ipv6subnet;
  @attr("yesno") routable;

  @belongsTo("private-network", { async: false, inverse: "segments" }) privateNetwork;
  @belongsTo("data-center", { async: false, inverse: null }) dataCenter;
  @hasMany("network-adapter", { async: false, inverse: "segment" }) networkAdapters;

  get supportsRouting() {
    return this.platform === "vmware" && Boolean(this.dataCenter?.hasRoutableSegmentSupport);
  }

  get connectedServerCount() {
    let serverIds = this.networkAdapters.map((adapter) => adapter.server?.id).filter(Boolean);

    return new Set(serverIds).size;
  }

  deleteTask = task(async () => {
    this.deleteRecord();

    try {
      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();

      throw error;
    }
  });

  updateTask = task(async ({ name, routable }) => {
    this.name = name;
    this.routable = routable;

    try {
      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();

      throw error;
    }
  });
}
